export const formGosReportFields = {
  PERIOD_YEAR: 'year',
  DATE_FROM: 'startPeriod',
  DATE_TO: 'endPeriod',
  LEGAL_ENTITY_ID: 'legalEntityId',

  PAGE: 'page',
  PAGE_SIZE: 'size',
};
